import axios from "axios";
import {useEffect, useState} from "react";
import {useParams} from 'react-router-dom';
import Swal from 'sweetalert2';
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js'
function EditToDo() {
    const {id} = useParams();
    const [tasks, settasks] = useState([]);
    const [taskData, settaskData] = useState({
        "category": '',
        "priority": '',
        "description": '',
        "status": '',
        "addedby": '',
        "ip_add": '',
    });
    useEffect(() => {
        try {
            axios.get(baseUrl + "get-todo/")
                .then(function (response) {
                    settasks(response.data);
                });
        } catch (error) {
            console.log(error);
        }
    }, []);
    useEffect(() => {
        try {
            axios.get(baseUrl + 'edit-todo/' + id)
                .then(function (response) {
                    settaskData({
                        category: response.data.category,
                        priority: response.data.priority,
                        description: response.data.description,
                        status: response.data.status
                    });
                });
        } catch (error) {
            console.log(error);
        }
    }, []);
    const handleChange = (event) => {
        settaskData({
            ...taskData,
            [event.target.name]: event.target.value
        });
    }
    const formSubmit = () => {
        const _formData = new FormData();
        _formData.append('category', taskData.category);
        _formData.append('priority', taskData.priority);
        _formData.append('description', taskData.description);
        _formData.append('status', taskData.status);
        _formData.append('addedby', userName);
        _formData.append('ip_add', ipAddress);
        _formData.append('location', userLocation);
        try {
            axios.put(baseUrl + 'edit-todo/' + id, _formData, {
                headers: {
                    'content-type': 'multiple/form-data'
                }
            })
                .then(function (response) {
                    if (response.status == 200) {
                        Swal.fire({
                            title: 'Data has been updated',
                            icon: 'success',
                            timer: 2000,
                            showConfirmButton: false
                        });
                    }
                    setTimeout(() => {
                        window.location.href = ('/todolist');
                    }, 2000);
                });
        } catch (error) {
            console.log(error);
        }
    };
    return (
        <section className="container mt-4">
            <div className="row">
                <div className='col-md-9 col-12 mb-2'>
                    <div className='card'>
                        <h4 className='card-header'>Edit To Do List</h4>
                        <div className='card-body'>
                            <form>
                                <div className="mb-3">
                                    <label htmlFor="status" className="form-label">Status</label>
                                    <select name="status" value={taskData.status} onChange={handleChange}
                                            className="form-control">
                                        <option>Choose Status</option>
                                        {tasks.map((status, index) => (
                                            <option key={index} value={status.status}>
                                                {status.status == '1' ? 'Pending' : 'Completed'}
                                            </option>
                                        ))}
                                        <option value="2">Completed</option>
                                        <option value="1">Pending</option>
                                    </select>
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="Category" className="form-label">Category</label>
                                    <input type="text" className="form-control" name="category"
                                           value={taskData.category}
                                           onChange={handleChange} id="category" required/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="Priority" className="form-label">Priority</label>
                                    <select name="priority" value={taskData.priority} onChange={handleChange}
                                            className="form-control">
                                        <option>Choose Priority</option>
                                        <option value="Low">Low</option>
                                        <option value="High">High</option>
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="amount" className="form-label">Amount</label>
                                    <textarea className="form-control" name="description" value={taskData.description}
                                              onChange={handleChange} id="description" required>
                            </textarea>
                                </div>

                                <button type="button" onClick={formSubmit} className="btn btn-primary">Submit</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
export default EditToDo;